import revive_payload_client_4sVQNw7RlN from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/usr/code/docker/www/formx/client/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/usr/code/docker/www/formx/client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/usr/code/docker/www/formx/client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/usr/code/docker/www/formx/client/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/usr/code/docker/www/formx/client/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import slideovers_LDumGYo2KH from "/usr/code/docker/www/formx/client/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.mjs";
import modals_bidRKewKK5 from "/usr/code/docker/www/formx/client/node_modules/@nuxt/ui/dist/runtime/plugins/modals.mjs";
import colors_244lXBzhnM from "/usr/code/docker/www/formx/client/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_OVoKJro5pc from "/usr/code/docker/www/formx/client/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import motion_fmZWau4t0U from "/usr/code/docker/www/formx/client/node_modules/@vueuse/motion/dist/runtime/templates/motion.mjs";
import chunk_reload_client_UciE0i6zes from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import amplitude_EZuIopuxgB from "/usr/code/docker/www/formx/client/plugins/amplitude.js";
import crisp_client_amQNA6tQA4 from "/usr/code/docker/www/formx/client/plugins/crisp.client.js";
import featureFlags_yTfIldzVS7 from "/usr/code/docker/www/formx/client/plugins/featureFlags.js";
import pinia_history_Fm3e3342Dv from "/usr/code/docker/www/formx/client/plugins/pinia-history.js";
import sentry_PZVGm6LH3G from "/usr/code/docker/www/formx/client/plugins/sentry.js";
import vue_confetti_client_S5fochbKaT from "/usr/code/docker/www/formx/client/plugins/vue-confetti.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  slideovers_LDumGYo2KH,
  modals_bidRKewKK5,
  colors_244lXBzhnM,
  plugin_client_OVoKJro5pc,
  motion_fmZWau4t0U,
  chunk_reload_client_UciE0i6zes,
  amplitude_EZuIopuxgB,
  crisp_client_amQNA6tQA4,
  featureFlags_yTfIldzVS7,
  pinia_history_Fm3e3342Dv,
  sentry_PZVGm6LH3G,
  vue_confetti_client_S5fochbKaT
]